import React from 'react';
import makeIconName from '../../utils/makeIconName';
import styles from './index.module.scss';
const Burger = ({ onClick }) => {
    return (React.createElement("button", { className: styles.burgerBtn, onClick: (e) => onClick(e), type: 'button', "aria-label": 'NavBar' },
        React.createElement("i", { className: makeIconName('burger', 'x24') })));
};
export default Burger;
